import { GetRequireApprovePoint } from "services/interface";
import {
  Avatar,
  Button,
  Image,
  message,
  Modal,
  Popconfirm,
  Typography,
} from "antd";
import React from "react";
import { numberFormat } from "utils/nuberFormat";
import { formatDateWithTime } from "utils/dateFormat";
import { useApproveRequireApprovePoint } from "hooks/usePoint";
import { useQueryClient } from "@tanstack/react-query";

interface ModalPointDetailProps {
  isShow: boolean;
  onClose: () => void;
  editData: GetRequireApprovePoint | undefined;
}

const ModalPointDetail = ({
  isShow,
  onClose,
  editData,
}: ModalPointDetailProps) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useApproveRequireApprovePoint();

  return (
    <div>
      <Modal
        title="รายละเอียดการเติม Point"
        open={isShow}
        maskClosable={false}
        onCancel={() => {
          onClose();
        }}
        width={400}
        style={{ top: 20 }}
        footer={null}
      >
        <div>
          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <Avatar
              size={{ xs: 24, sm: 32, md: 40, lg: 54, xl: 60, xxl: 80 }}
              src={editData?.image}
            />
          </div>
          <div>
            <Typography.Text style={{ fontWeight: 400, fontSize: 14 }}>
              ชื่อผู้เติม :{" "}
            </Typography.Text>
            <Typography.Text>{editData?.name}</Typography.Text>
          </div>
          <div>
            <Typography.Text style={{ fontWeight: 400, fontSize: 14 }}>
              เบอร์โทร :{" "}
            </Typography.Text>
            <Typography.Text>{editData?.telephone}</Typography.Text>
          </div>
          <div>
            <Typography.Text style={{ fontWeight: 400, fontSize: 14 }}>
              {" "}
              จำนวนเงิน :{" "}
            </Typography.Text>
            <Typography.Text>
              {numberFormat(editData?.money_amt ?? 0)} บาท{" "}
            </Typography.Text>
          </div>
          <div>
            <Typography.Text style={{ fontWeight: 300, fontSize: 14 }}>
              จำนวน Point ที่ได้รับ :{" "}
            </Typography.Text>
            <Typography.Text>
              {numberFormat(editData?.point_amt ?? 0)} Point{" "}
            </Typography.Text>
          </div>

          <div style={{ display: "flex", flexDirection: "row" }}>
            <Avatar size="small" src={editData?.bank_logo} />
            <div style={{ marginLeft: 10 }}>
              <Typography.Text style={{ fontWeight: 400, fontSize: 14 }}>
                ธนาคาร :{" "}
              </Typography.Text>
              <Typography.Text>{editData?.bank_name}</Typography.Text>
            </div>
          </div>
          <div style={{}}>
            <Typography.Text style={{ fontWeight: 400, fontSize: 14 }}>
              เลขที่บัญชี :{" "}
            </Typography.Text>
            <Typography.Text>{editData?.account_no}</Typography.Text>
          </div>
          <div style={{}}>
            <Typography.Text style={{ fontWeight: 400, fontSize: 14 }}>
              ชื่อบัญชี :{" "}
            </Typography.Text>
            <Typography.Text>{editData?.account_name}</Typography.Text>
          </div>
          <div style={{}}>
            <Typography.Text style={{ fontWeight: 400, fontSize: 14 }}>
              วันที่เติม :{" "}
            </Typography.Text>
            <Typography.Text>
              {formatDateWithTime(editData?.create_date || "")}
            </Typography.Text>
          </div>
          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <Image src={editData?.image_slip} width={400} />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            marginTop: 10,
          }}
        >
          <Popconfirm
            title="คุณต้องการอนุมัติการเติม Point ใช่หรือไม่?"
            description="เมื่อกดยืนยัน จะไม่สามารถยกเลิกได้ กรุณาตรวจสอบการโอนเงินให้ดีก่อนยืนยัน"
            onConfirm={() => {
              if (editData) {
                mutate(
                  {
                    id: editData.id,
                  },
                  {
                    onSuccess: async (data) => {
                      if (!data.error_message) {
                        await queryClient.refetchQueries({
                          queryKey: ["require_approve_point"],
                          type: "active",
                        });
                        message.success("อนุมัติการเติม Point สำเร็จ");
                        onClose();
                      } else {
                        message.error(data.error_message);
                      }
                    },
                  }
                );
              }
            }}
            onOpenChange={() => console.log("open change")}
            disabled={isPending}
          >
            <Button disabled={isPending} type="primary">
              อนุมัติ
            </Button>
          </Popconfirm>
        </div>
      </Modal>
    </div>
  );
};

export default ModalPointDetail;
